import { render, staticRenderFns } from "./fatFile-add.vue?vue&type=template&id=970da6de&scoped=true&"
import script from "./fatFile-add.vue?vue&type=script&lang=js&"
export * from "./fatFile-add.vue?vue&type=script&lang=js&"
import style0 from "./fatFile-add.vue?vue&type=style&index=0&id=970da6de&prod&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "970da6de",
  null
  
)

export default component.exports